import FadeDiv from "./common/FadeDiv";
import React from "react";
import clsx from "clsx";

interface GailComparisonCardProps {
  title: string;
  description: string;
  image: React.ReactNode;
  imageOnLeft?: boolean;
  disableFade?: boolean;
}

const GailComparisonCard: React.FC<GailComparisonCardProps> = ({
  title,
  description,
  image,
  imageOnLeft = true,
  disableFade = false,
}) => {
  const content = (
    <>
      <div
        className={clsx(
          "md:w-1/2",
          "lg:w-7/12",
          "min-h-[60vw]",
          "md:min-h-full",
          "md:h-full",
          "flex",
          "items-center",
          "justify-center",
          "[&>img]:object-contain",
          "[&>img]:h-full",
          "[&>img]:w-full",
          "md:rounded-xl",
          "px-4",
          "rounded-lg",
          "mt-4"
        )}
      >
        {image}
      </div>
      <div
        className={clsx(
          "w-full",
          "md:w-1/2",
          "lg:w-5/12",
          "text-left",
          "py-4",
          "px-4",
          "lg:px-8",
          "flex",
          "flex-col",
          "flex-grow"
        )}
      >
        <h2
          className={clsx(
            "text-xl md:text-[28px]",
            "font-medium",
            "mb-3",
            "leading-6"
          )}
        >
          {title}
        </h2>
        <div className={clsx("max-w-md", "mt-auto")}>
          <p className={clsx("leading-tight", "md:text-xl")}>{description}</p>
        </div>
      </div>
    </>
  );
  return disableFade ? (
    <div
      className={clsx(
        "flex",
        "flex-col",
        "md:px-4",
        "md:px-12",
        "lg:px-16",
        "items-center",
        "md:flex-row",
        { "md:flex-row-reverse": imageOnLeft }
      )}
    >
      {content}
    </div>
  ) : (
    <FadeDiv
      className={clsx(
        "flex",
        "flex-col",
        "md:px-4",
        "md:px-12",
        "lg:px-16",
        "items-center",
        "md:flex-row",
        { "md:flex-row-reverse": imageOnLeft }
      )}
    >
      {content}
    </FadeDiv>
  );
};

export default GailComparisonCard;
